import React, { memo, useEffect, useRef } from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { Input } from "reactstrap";

import { EnumTaxonomyEntry } from "../../types";
import { InputComponentProps } from "./common";

const EnumInputComponent = ({
  active,
  dataPoint,
  id,
  onFocus,
  onUpdate,
  value,
}: InputComponentProps<EnumTaxonomyEntry, string>) => {
  const focusRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (!focusRef.current) {
      return;
    }
    if (active && focusRef.current.focus) {
      focusRef.current.focus();
    } else if (focusRef.current.blur) {
      focusRef.current.blur();
    }
  }, [active]);

  return (
    <Input
      className="custom-select"
      id={id}
      innerRef={focusRef}
      onChange={e => {
        onUpdate(id, e.target.value, e.target.value);
      }}
      onFocus={() => {
        onFocus(id);
      }}
      type="select"
      value={value.value}
    >

      {// add an empty selection if value is not found in dropdown or if not required
        (!dataPoint.required || dataPoint.options.findIndex(item => value.valueRaw.trim().toLowerCase() === item.trim().toLowerCase()) == -1) && <option value="" />
      }

      {dataPoint.options.map((o, i) => (
        <option key={`${o}-${i}`} value={o}>
          {o}
        </option>
      ))}
    </Input>
  );
};
EnumInputComponent.displayName = "EnumInput";
export const EnumInput = memo(EnumInputComponent);
